<template>
  <div>

    <div class="d-block d-sm-block d-md-none">
      <BannerTopMobile
        :image="`${url_banners_mobile}/images/mobile/banner3.jpg`"
      ></BannerTopMobile>
    </div>

    <div class="row mt-15 mb-10 d-none d-sm-none d-md-block">
      <div class="col-3" style="padding: 0 !important">
        <router-link to="/">
          <img class="logo-store ml-3" src="@/assets/store/home/svglogo.svg" alt="">
        </router-link>
      </div>
    </div>

    <v-dialog
      v-model="open_cart"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          color="#fff"
          elevation="0"
        >
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="open_cart = false"
            class="mr-2"
          >
            <v-icon large color="accent">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <Cart @closeModal="open_cart = false" :flavors="data_home_page.flavors"></Cart>

      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import Cart from '@/components/store/Cart'

import { mapState } from 'vuex'

export default {
  components: {
    Cart
  },
  data() {
    return {
      url_banners_mobile: process.env.VUE_APP_URL_FILES,
      open_cart: false
    }
  },
  computed: {
    ...mapState(['cart', 'data_home_page'])
  },
  methods: {

  }
}
</script>
